module.exports = __webpack_public_path__ + "static/media/internet-tab.ec0c4ccc.svg";